import React, { useEffect, useState } from "react";
import { Select } from "antd";
import { useDispatch } from "react-redux";
import { getAuditLogDetails, getSubFilterDetails } from "../../../redux/slices";
import { SALES_AUDIT_OPTIONS_MAP } from "../../../data/constants";
const { Option } = Select;

interface Props {
  auditFilterDetails: any;
  getPayload: any;
  selectedItemId: string;
  onSelectedItemChange: any;
  defaultSelectedSubType: string;
}

function AuditSubFilterDropdown(props: Props) {
  const {
    auditFilterDetails,
    getPayload,
    selectedItemId,
    onSelectedItemChange,
    defaultSelectedSubType,
  } = props;
  const [selectedItem, setSelectedItem] = useState<string>(
    defaultSelectedSubType
  );
  const dispatch = useDispatch();
  useEffect(() => {
    setSelectedItem("");
  }, [selectedItemId]);

  const dropdownStyle = {
    color:"#777777"
  };

  const handleItemChange = (value: any) => {
    let dataToPost = getPayload();
    setSelectedItem(value);
    if (value) {
      dataToPost["auditType"] = SALES_AUDIT_OPTIONS_MAP[selectedItemId].label;
      dataToPost["auditSubType"] = value;
    }
    dispatch(getAuditLogDetails({ dataToPost }));
    dispatch(getSubFilterDetails({ dataToPost, isSubType: true }));
    onSelectedItemChange(value);
  };
  let placeholder = `Select ${SALES_AUDIT_OPTIONS_MAP[selectedItemId].placeholderText}`;

  return (
    <>
      {auditFilterDetails?.auditSubTypes?.length > 0 && (
        <Select
          value={selectedItem || defaultSelectedSubType}
          onChange={handleItemChange}
          placeholder={placeholder}
          style={dropdownStyle}
          suffixIcon={
            <div className="rista-sprite ic-dropdown-arrow-down2 "></div>
          }
          className={`custom-dropdown  w-[150px] focus:!bg-transparent flex items-center justify-center !rounded-lg overflow-hidden !h-[41px]`}
        >
          <>
            <Option key={""} value={""} className={"focus:bg-[#E0E0E0]"}>
              {placeholder}
            </Option>
            {auditFilterDetails?.auditSubTypes?.map(
              (item: any, index: number) => (
                <Option key={index} value={item}>
                  {item}
                </Option>
              )
            )}
          </>
        </Select>
      )}
    </>
  );
}

export default AuditSubFilterDropdown;
